import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lj_phone",
  "use": "icon-lj_phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lj_phone\">\r\n    <path d=\"M256 846c0 61.7 51 111.7 114 111.7h285c63 0 114-50 114-111.7V678.4H256V846z m256.6-111.7c31.5 0 57 25 57 55.8 0 30.8-25.5 55.8-57 55.8s-57-25-57-55.8c0-30.8 25.5-55.8 57-55.8zM256 622.6h513V259.7H256v362.9zM655.1 64.2h-285c-63 0-114 50-114 111.7v27.9h513v-27.9c0-61.7-51-111.7-114-111.7z\" p-id=\"10398\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol